import ApplicationLoader from "./application-loader.js";

window.NewsServiceApplicationLoaderCalendar = ApplicationLoader;
